var _gaq = _gaq || []; // backward compatibility for other modules

var domain = 'acclipse.com';

try {
    domain = document.location.hostname.substring(document.location.hostname.indexOf('.') + 1);

} catch (e) {}

var tenantName;
try {
    tenantName = document.location.hostname.replace(domain, '');
} catch (e) { }

var gaPageHelper = (function () {
    var currentUrl = undefined;
    var loadingStartTime = undefined; 

    return {
        getUrl: function () {
            var urlPart = location.pathname + location.hash + location.search;
            var params = undefined;
            if (urlPart.indexOf('?') != -1) {
                params = urlPart.substring(urlPart.indexOf('?') + 1);
                urlPart = urlPart.substring(0, (urlPart.indexOf('?') - 1));

                var r = new RegExp('mode=([A-Za-z0-9_]+)', 'i');
                var m = r.exec(params);
                if (m != null) {
                    urlPart += "/" + m[1];
                }
            }

            return { url: urlPart, queryString: params };
        },
        loadCompleted: function () {
            setTimeout(function () {
                var pageloadTimeMs = Math.abs((new Date() - loadingStartTime));
                googleAnalytics.sendNavigationEvent(currentUrl);
                googleAnalytics.sendPageView(currentUrl);
                googleAnalytics.sendPageLoadTime(pageloadTimeMs);
            }, 0);
            
        },
        setCurrentPage: function (evt) {
            try {
                loadingStartTime = new Date();
                var url = location.pathname + location.hash
                currentUrl = excludeQueryString(url);
            } catch (e) { }
        }
    }
})();

var googleAnalytics = (function () {

    var isInitialized = function () {
        return typeof (window.dataLayer) !== "undefined"
    };
    
    function gtag() {
       window.dataLayer = window.dataLayer || [];
       window.dataLayer.push(arguments);
    }

    function getCurrentPageTitle() {
        return (document.title && document.title.indexOf('|') < document.title.length ? document.title.split('|')[0].trim() : document.title);
    }

    return {
        init: function () {
            if (!isInitialized() && appFeatureSwitches.googleAnalyticsMeasurementId) {
                try {
                    var script = document.createElement('script');
                    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + appFeatureSwitches.googleAnalyticsMeasurementId;
                    script.async = true;
                    var scripts = document.getElementsByTagName('script');
                    if (scripts && scripts.length && scripts.length > 0) {
                        scripts[0].parentNode.insertBefore(script, scripts[0]);
                    } else {
                        document.head.appendChild(script);
                    }
                    
                    gtag('js', new Date());
                    gtag('config', appFeatureSwitches.googleAnalyticsMeasurementId, {
                        'anonymize_ip': true,
                        'allow_google_signals': false,
                        'allow_ad_personalization_signals': false,
                        'restricted_data_processing': true,
                        'custom_map': {
                            'dimension1': 'Domain',
                            'dimension2': 'Tenant',
                            'dimension3': 'Params',
                            'dimension4': 'PageProvidedSectionOfThePage'
                        }
                    });

                    gtag('consent', 'default', {
                        'ad_storage': 'denied'
                    });

                } catch (e) {
                    console.log("Google Analytics Initialization failed");
                }
            }
        },

        sendNavigationEvent: function (nextPage) {
            if (isInitialized()) {
                gtag('event', 'navigate_to_page', {
                    'event_label': nextPage,
                    'event_category': 'ajax',
                    'value': 1,
                    'Domain': domain,
                    'Tenant': tenantName,
                });
            }
        },

        sendAjaxEvent: function (fullUrl) {
            if (isInitialized()) {
                gtag('event', 'ajax_request_completed', {
                    'event_label': fullUrl,
                    'event_category': 'ajax',
                    'value': 3,
                    'Domain': domain,
                    'Tenant': tenantName,
                });
            }
        },

        sendPageLoadTime: function (loadTime) {
            if (isInitialized()) {
                gtag('event', 'timing_complete', {
                    'name': 'load',
                    'value': loadTime,
                    'event_category': 'JS Dependencies',
                    'Domain': domain,
                    'Tenant': tenantName,
                });
            }
        },
        sendPageView: function (url) {
            if (isInitialized() && url) {
                var urlInfo = gaPageHelper.getUrl();
                url = url.replace("/#/", "/");
                gtag('event', 'page_view', {
                    'page_title': getCurrentPageTitle(),
                    'page_location': url,
                    'page_path': url,
                    'send_to': appFeatureSwitches.googleAnalyticsMeasurementId,
                    'Domain': domain,
                    'Tenant': tenantName,
                    'Params': urlInfo && urlInfo.queryString ? urlInfo.queryString : 'undefined'
                });
            }
        },

        sendPageProvidedSectionOfThePage: function (sectionName) {
            if (isInitialized()) {
                var urlInfo = gaPageHelper.getUrl();
                var url = urlInfo.url.replace("/#/", "/");
                gtag('event', 'page_view', {
                    'page_title': getCurrentPageTitle(),
                    'page_location': url,
                    'page_path': url,
                    'send_to': appFeatureSwitches.googleAnalyticsMeasurementId,
                    'PageProvidedSectionOfThePage': sectionName
                });
            }
        },
    };
})();

if (document.location.host.indexOf(domain) && appFeatureSwitches.googleAnalyticsMeasurementId) {
    //Initialize google analytics add it as first script in header.

    appFeatureSwitches.googleAnalyticsSamplingRate = parseInt(appFeatureSwitches.googleAnalyticsSamplingRate);
    if (isNaN(appFeatureSwitches.googleAnalyticsSamplingRate)) {
        appFeatureSwitches.googleAnalyticsSamplingRate = 100;
    }

    appFeatureSwitches.googleAnalyticsSamplingRate = Math.min(Math.abs(appFeatureSwitches.googleAnalyticsSamplingRate), 100);

    googleAnalytics.init();
    var urlParts = gaPageHelper.getUrl();

    googleAnalytics.sendPageView(urlParts.url);
    window.onhashchange = trackPageChange;
}

function trackAjaxEvents() {

    if (document.location.host.indexOf(domain)) {
        $(document).ajaxSuccess(function (evt, request, settings) {
            try {

                var fullUrl = settings.url;

                if (/IsLoggedOn/.test(settings.url) || /breadcrumbs-get.php/.test(settings.url) || /ActionList/.test(settings.url)) {
                    return;
                }

                //Strip out version...
                fullUrl = fullUrl.replace(/-\d+./, '.');
                fullUrl = excludeQueryString(fullUrl);

                if (/.tpl/.test(settings.url)) {
                    //Ignore templates
                    return;
                }

                if (/.js/.test(settings.url)) {
                    //Ignore javascript
                    return;
                }

                googleAnalytics.sendAjaxEvent(fullUrl);
                
            } catch (err) { }
        });
    }
}

function trackPageChange(e) {
    gaPageHelper.setCurrentPage(e);
};

function excludeQueryString(fullUrl) {
    if (fullUrl && fullUrl.indexOf('?') != -1) {
        fullUrl = fullUrl.substring(0, fullUrl.indexOf('?'));
    }

    return fullUrl;
};

function getHostName(url) {

    var hostName = null;
    var protocol = location.protocol;
    var protocalLength = protocol.length + 2;
    if (url && url.length > protocalLength) {
        url = url.substring(protocalLength);
    }

    if (url) {
        hostName = url.substring(0, url.indexOf("/"));
    }

    return hostName;
}

function getPreviousPage(e) {
    var previousPage = null;
    if (e && e.oldURL) {
        var scheme = location.protocol;
        var previousUrl = excludeQueryString(e.oldURL);
        var previousHostName = getHostName(previousUrl);
        if (previousHostName && previousUrl && previousUrl.indexOf(previousHostName) != -1) {
            previousPage = previousUrl.substring(previousUrl.indexOf(previousHostName) + previousHostName.length);
        }
    }

    return previousPage;
}